
import Config from "../config";
import {FileModel} from '../models/models';
import {FlowRunModel,
        FlowScreenModel,
        FlowRunFactory,
        FlowScreenFactory,
        FlowSuccessModel,
        FlowSuccessFactory} from '../models/modelsFlow';


export const startFlow = async (authToken: string,
                                targetObjectApiName: string | null,
                                targetRecordUuid: string | null,
                                flowUuid: string): Promise<{'flowRun': FlowRunModel | null,
                                                              'flowScreen': FlowScreenModel | null,
                                                               'flowSuccess': FlowSuccessModel | null}> => {
    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/flows/start/${flowUuid}`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

//      const flowRunJSON = new FlowRunFactory().toJSON(flowRun);
//      const flowScreenJSON = new FlowScreenFactory().toJSON(flowScreen);
//      const body = {'flow_run': flowRunJSON,
//                    'flow_screen': flowScreenJSON}
      const body = {'target_object_api_name': targetObjectApiName,
                    'target_record_uuid': targetRecordUuid}

      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();
      if(!data){
          throw new Error("Unhandled error")
      }

      if(!data.flow_run &&
         !data.flow_screen &&
         !data.status){
          throw new Error("Unhandled error")
      }


      const thisPromise = {'flowRun': null as FlowRunModel | null,
                           'flowScreen': null as FlowScreenModel | null,
                           'flowSuccess': null as  FlowSuccessModel | null}

      if(data.status && data.status=='ok'){
        const newFlowSuccess = new FlowSuccessFactory().fromJSON(data)
        thisPromise.flowSuccess = newFlowSuccess;
      }

      if(data.flow_run){
        const newFlowRun = new FlowRunFactory().fromJSON(data.flow_run)
        thisPromise.flowRun = newFlowRun;
      }

      if(data.flow_screen){
        const newFlowScreen = new FlowScreenFactory().fromJSON(data.flow_screen)
        thisPromise.flowScreen = newFlowScreen;
      }

      return thisPromise

    } catch (error){
      throw new Error(`Error when executing flow step: ${(error as Error).message}`)
    }
}




export const executeFlowStep = async (authToken: string, flowRun: FlowRunModel, flowScreen: FlowScreenModel): Promise<{'flowRun': FlowRunModel | null,
                                                                                                                        'flowScreen': FlowScreenModel | null,
                                                                                                                        'flowSuccess': FlowSuccessModel | null}> => {

    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/flows/submit`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);

      const flowRunJSON = new FlowRunFactory().toJSON(flowRun);
      const flowScreenJSON = new FlowScreenFactory().toJSON(flowScreen);
      const requestBody = {'flow_run': flowRunJSON,
                    'flow_screen': flowScreenJSON}

      const allFiles = new FlowScreenFactory().getFILES(flowScreen);

      const requestBlob = new Blob([JSON.stringify(requestBody)], {type: "application/json"});

      const formData = new FormData();
      formData.append('json', requestBlob, 'flow_screen.json')

      allFiles.map((thisFile: FileModel) => {
        formData.append(`${thisFile.fieldName}-${thisFile.fileName}`, thisFile.file, thisFile.fileName)
      })

      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: formData
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();
      if(!data){
          throw new Error("Unhandled error")
      }

      if(!data.flow_run &&
         !data.flow_screen &&
         !data.status){
          throw new Error("Unhandled error")
      }


      const thisPromise = {'flowRun': null as FlowRunModel | null,
                           'flowScreen': null as FlowScreenModel | null,
                           'flowSuccess': null as  FlowSuccessModel | null}

      if(data.status && data.status=='ok'){
        const newFlowSuccess = new FlowSuccessFactory().fromJSON(data)
        thisPromise.flowSuccess = newFlowSuccess;
      }

      if(data.flow_run){
        const newFlowRun = new FlowRunFactory().fromJSON(data.flow_run)
        thisPromise.flowRun = newFlowRun;
      }

      if(data.flow_screen){
        const newFlowScreen = new FlowScreenFactory().fromJSON(data.flow_screen)
        thisPromise.flowScreen = newFlowScreen;
      }

      return thisPromise

    } catch (error){
      throw new Error(`Error when executing flow step: ${(error as Error).message}`)
    }
}
